import React from 'react';
import dateFormat from '../../../../../utils/date-format';
import globalSettingsStores from '../../../../../stores/settings-stores';

interface LectureDateWithVacationProps {
  startTime: Date | string;
}

export const LectureDateWithVacation: React.FC<
  LectureDateWithVacationProps
> = ({ startTime }) => {
  const start = new Date(startTime);
  const dateText = dateFormat.displayFormatDate(startTime);

  const isVacation = (() => {
    const normalized = new Date(
      start.getFullYear(),
      start.getMonth(),
      start.getDate(),
      0,
      0,
      0,
      0,
    );

    for (const v of globalSettingsStores.calendarVacations || []) {
      const s = v.startDate ? new Date(v.startDate as any) : null;
      const e = v.endDate ? new Date(v.endDate as any) : null;

      const sN = s
        ? new Date(s.getFullYear(), s.getMonth(), s.getDate(), 0, 0, 0, 0)
        : null;
      const eN = e
        ? new Date(e.getFullYear(), e.getMonth(), e.getDate(), 0, 0, 0, 0)
        : null;

      if (sN && eN) {
        if (normalized >= sN && normalized <= eN) {
          return { title: v.title };
        }
      } else if (sN) {
        if (normalized.getTime() === sN.getTime()) {
          return { title: v.title };
        }
      } else if (eN) {
        if (normalized.getTime() === eN.getTime()) {
          return { title: v.title };
        }
      }
    }
    return null;
  })();

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <span>{dateText}</span>
      {isVacation && (
        <span
          className="lecture-vacation-icon"
          data-pr-tooltip={`חופשה: ${isVacation.title ?? ''}`}
          data-pr-position="top"
          title={`חופשה: ${isVacation.title ?? ''}`}
          style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
        >
          <i
            className="pi pi-exclamation-triangle"
            style={{ color: '#f59e0b' }}
          />
        </span>
      )}
    </div>
  );
};
